export default __webpack_public_path__ + "static/media/Ballroll_00145.5f7dba09.png";